<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 평가기간 -->
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            LBL0000607="6M"
            label="LBL0000607"
            name="assessmentDates"
            v-model="searchParam.assessmentDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 평가구분-정기/수시/최초 -->
          <c-select
            codeGroupCd="RAM_ASSESS_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ramAssessTypeCd"
            label="LBL0001041"
            v-model="searchParam.ramAssessTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="stepItems"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ramStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.ramStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 위험성평가 목록 -->
    <c-table
      ref="table"
      title="LBL0001042"
      tableId="4"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable && !searchParam.isVendor"
            label="LBLREG"
            icon="add_circle"
            @btnClicked="addRisk"
          />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "riskList",
  data() {
    return {
      searchParam: {
        plantCd: null,
        assessmentDates: [],
        ramAssessTypeCd: null,
        ramStepCd: null,
        ramTechniqueCd: "",
        isVendor: false,
        approvalUserId: "",
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "assessmentManageDeptName",
            field: "assessmentManageDeptName",
            label: "진행부서",
            align: "center",
            style: "width:140px",
            sortable: true,
          },
          {
            name: "assessmentName",
            field: "assessmentName",
            // 평가명
            label: "LBL0000367",
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "ramStepName",
            field: "ramStepName",
            label: "LBLSTEPPROGRESS",
            align: "center",
            style: "width:200px",
            sortable: true,
          },
          {
            name: "assessmentDate",
            field: "assessmentDate",
            // 평가기간
            label: "LBL0000607",
            align: "center",
            style: "width:180px",
            sortable: true,
          },
          {
            name: "ramAssessTypeName",
            field: "ramAssessTypeName",
            // 평가구분
            label: "LBL0000608",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "regUserName",
            field: "regUserName",
            label: "LBLREGISTER",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "reviewUserName",
            field: "reviewUserName",
            label: "LBLREVIEWER",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            name: "approvalUserName",
            field: "approvalUserName",
            label: "LBLAPPROVER",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
        ],
        data: [],
      },
      stepItems: [],
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.assessPlan.list.url;
      // code setting
      this.$comm.getStepItems("RAM_RISK_STEP_CD").then((_result) => {
        _result.splice(1, 1);
        this.stepItems = _result;
      });
      this.$set(
        this.searchParam,
        "ramTechniqueCd",
        this.$route.meta.params.ramTechniqueCd,
      );
      if (this.$route.meta.params.approvalUserId) {
        this.$set(
          this.searchParam,
          "approvalUserId",
          this.$store.getters.user.userId,
        );
        this.$set(this.searchParam, "isVendor", true);
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    addRisk() {
      this.linkClick();
    },
    linkClick(row) {
      this.popupOptions.title = "LBL0001040"; // 위험성평가 상세
      this.popupOptions.param = {
        ramRiskAssessmentPlanId: row ? row.ramRiskAssessmentPlanId : "",
        ramStepCd: row ? row.ramStepCd : "RRS0000001",
        vendorFlag: row ? row.vendorFlag > 0 : false,
        ramTechniqueCd: row ? row.ramTechniqueCd : "RT00000025",
      };
      this.popupOptions.target = () => import(`${"./riskDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
